import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookieConsent } from '../../context/CookieConsentContext';

export const Footer = ({ variant = 'dark' }) => {
  const navigate = useNavigate();
  const { openSettings } = useCookieConsent();

  const isDark = variant === 'dark';

  return (
    <footer 
      className={`py-12 ${isDark ? 'bg-navy text-white' : 'bg-white border-t border-black/5'}`}
      data-testid="legal-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Logo */}
          <button
            onClick={() => navigate('/')}
            className={`font-playfair text-xl font-bold transition-colors ${
              isDark ? 'text-white hover:text-white/80' : 'text-navy hover:text-charcoal'
            }`}
          >
            Nico Helfrich
          </button>
          
          {/* Legal Links */}
          <div className={`flex flex-wrap justify-center gap-6 md:gap-8 text-sm ${
            isDark ? 'text-white/60' : 'text-slate'
          }`}>
            <button
              onClick={() => navigate('/impressum')}
              className={`hover:${isDark ? 'text-white' : 'text-navy'} transition-colors`}
              data-testid="footer-impressum-link"
            >
              Impressum
            </button>
            <button
              onClick={() => navigate('/datenschutz')}
              className={`hover:${isDark ? 'text-white' : 'text-navy'} transition-colors`}
              data-testid="footer-datenschutz-link"
            >
              Datenschutz
            </button>
            <button
              onClick={openSettings}
              className={`hover:${isDark ? 'text-white' : 'text-navy'} transition-colors`}
              data-testid="footer-cookie-settings-link"
            >
              Cookie-Einstellungen
            </button>
          </div>
        </div>
        
        {/* Copyright */}
        <div className={`mt-8 pt-8 border-t ${isDark ? 'border-white/10' : 'border-black/5'} text-center text-xs ${isDark ? 'text-white/40' : 'text-slate/60'}`}>
          © {new Date().getFullYear()} Nico Helfrich. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
